// TopicPage.js
import React, { useEffect, useState, useContext } from "react";
import TopicCard from "../components/TopicCard.js";
import { AppContext } from "../AppContext";

const TopicPage = () => {
  const { API_BASE_URL } = useContext(AppContext);
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedGrade, setSelectedGrade] = useState("all");

  // Gọi API
  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/topics`);
        const data = await res.json();
        setTopics(data);
      } catch (err) {
        console.error("Lỗi tải topics:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchTopics();
  }, [API_BASE_URL]);

  // Lọc theo lớp
  const filteredTopics =
    selectedGrade === "all"
      ? topics
      : topics.filter((t) => parseInt(t.grade) === parseInt(selectedGrade)); // <-- Sửa lỗi ở đây

  return (
    <div className="container mx-auto px-4 py-12">
      <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-8 leading-tight">
        Danh sách chuyên đề
      </h2>

      {/* Bộ lọc theo lớp */}
      <div className="flex justify-center mb-10">
        <select
          value={selectedGrade}
          onChange={(e) => setSelectedGrade(e.target.value)}
          className="px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500"
        >
          <option value="all">Tất cả các lớp</option>
          <option value="6">Lớp 6</option>
          <option value="7">Lớp 7</option>
          <option value="8">Lớp 8</option>
          <option value="9">Lớp 9</option>
        </select>
      </div>

      {loading ? (
        <div className="text-center py-20">
          <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-green-600 mx-auto mb-5"></div>
          <p className="text-2xl text-gray-700">
            Đang tải danh sách chuyên đề...
          </p>
        </div>
      ) : filteredTopics.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {filteredTopics.map((topic) => (
            <TopicCard key={topic.id} topic={topic} />
          ))}
        </div>
      ) : (
        <div className="text-center py-20">
          <p className="text-2xl text-gray-700">
            Không có chuyên đề nào cho lớp đã chọn.
          </p>
        </div>
      )}
    </div>
  );
};

export default TopicPage;
